import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/icon-filter.svg'


const _hoisted_1 = {
  key: 0,
  class: "borrow-house-calculator-container"
}
const _hoisted_2 = {
  key: 0,
  class: "content-wr"
}
const _hoisted_3 = { class: "house-details-wr" }
const _hoisted_4 = { class: "content-builder-house" }
const _hoisted_5 = {
  key: 0,
  class: "builder-wr"
}
const _hoisted_6 = {
  key: 1,
  class: "house-wr"
}
const _hoisted_7 = { class: "content-images" }
const _hoisted_8 = { class: "land-package-wr" }
const _hoisted_9 = {
  key: 1,
  class: "content-floorplan-mobile"
}
const _hoisted_10 = {
  key: 2,
  class: "content-compare"
}
const _hoisted_11 = { class: "text-budget" }
const _hoisted_12 = {
  key: 1,
  class: "result-filter"
}
const _hoisted_13 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!$setup.loading && $setup.houseInfo && $setup.estateInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode($setup["BuilderHouseBorrowHeaderMobile"], {
            estate: $setup.estateInfo,
            onCalculate: $setup.onViewCalculator
          }, null, 8, ["estate"]),
          ($setup.houseInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    ($setup.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode($setup["BuilderLogo"], {
                            builderId: $setup.houseInfo.builderId,
                            builderData: $setup.builderInfo
                          }, null, 8, ["builderId", "builderData"])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode($setup["HouseNameAndFeatures"], { houseInfo: $setup.houseInfo }, null, 8, ["houseInfo"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode($setup["HouseAndFloorplanImage"], {
                      houseInfo: $setup.houseInfo,
                      quote: $setup.quoteInfo,
                      selectedFacade: $setup.selectedFacade,
                      onUpdateSelectedFacade: $setup.onUpdateSelectedFacade
                    }, null, 8, ["houseInfo", "quote", "selectedFacade"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode($setup["HouseAndLotDetails"], {
                    houseInfo: $setup.houseInfo,
                    lotSelected: $setup.deleteLot ? null : $setup.lotSelected,
                    estateInfo: $setup.estateInfo,
                    quote: $setup.quoteInfo,
                    builder: $setup.builderInfo,
                    selectedFacade: $setup.selectedFacade,
                    onUpdateLotSelected: _cache[0] || (_cache[0] = ($event: any) => ($setup.lotSelected = $event))
                  }, null, 8, ["houseInfo", "lotSelected", "estateInfo", "quote", "builder", "selectedFacade"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode($setup["FloorplanAndInclusionsMobile"], {
                  houseInfo: $setup.houseInfo,
                  "onUpdate:selectedFacade": $setup.onUpdateSelectedFacade
                }, null, 8, ["houseInfo"])
              ]))
            : _createCommentVNode("", true),
          ($setup.houseInfo)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString($setup.isDesktop ? "Compare other home designs:" : "Compare other home designs"), 1),
                (!$setup.isDesktop)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "button-filter",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openModalFilter()))
                    }, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("img", {
                        class: "filter-svg",
                        src: _imports_0
                      }, null, -1),
                      _createElementVNode("span", { class: "text-filter" }, "Filters", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (!$setup.isDesktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.houses?.length) + " Results:", 1))
                  : _createCommentVNode("", true),
                ($setup.isDesktop)
                  ? (_openBlock(), _createBlock($setup["FilterHouses"], {
                      key: 2,
                      result: $setup.resultForFilter,
                      lotSelected: $setup.lotSelected,
                      quote: $setup.quoteInfo,
                      houseDetailsView: true,
                      hasToLoadNextBatch: $setup.hasToLoadNextBatch,
                      onUpdateHousesPagination: $setup.onUpdateHousesPagination,
                      onHousesByFilter: $setup.housesByFilter
                    }, null, 8, ["result", "lotSelected", "quote", "hasToLoadNextBatch"]))
                  : _createCommentVNode("", true),
                _createVNode($setup["ListHouses"], {
                  houses: $setup.houses,
                  estate: $setup.estateInfo,
                  quote: $setup.quoteInfo,
                  result: $setup.resultForFilter,
                  houseDetailsView: true,
                  nextBatch: $setup.nextHousesBatch,
                  onOnClickHouse: $setup.refreshHouse,
                  onLoadNextBatch: $setup.onLoadNextBatch
                }, null, 8, ["houses", "estate", "quote", "result", "nextBatch"])
              ]))
            : _createCommentVNode("", true),
          (!$setup.isDesktop)
            ? (_openBlock(), _createBlock($setup["HouseQuestion"], { key: 3 }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13)),
    (!$setup.isDesktop)
      ? (_openBlock(), _createBlock($setup["BuilderFiltersHousesModal"], {
          key: 2,
          isOpen: $setup.isModalFiltersHousesHidden ? true : $setup.isOpenedModalFiltersHouses,
          result: $setup.resultForFilter,
          lotSelected: $setup.lotSelected,
          quote: $setup.quoteInfo,
          houseDetailsView: true,
          isModalFiltersHousesHidden: $setup.isModalFiltersHousesHidden,
          hasToLoadNextBatch: $setup.hasToLoadNextBatch,
          onHousesByFilter: $setup.housesByFilter,
          onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.isModalFiltersHousesHidden = true)),
          onUpdateHousesPagination: $setup.onUpdateHousesPagination
        }, null, 8, ["isOpen", "result", "lotSelected", "quote", "isModalFiltersHousesHidden", "hasToLoadNextBatch"]))
      : _createCommentVNode("", true)
  ]))
}